import { Position, PositionRange } from '../../types'

export function getVisiblePositionPercent(position: Position, visibleRange: PositionRange) {
  return (100 * (position - visibleRange[0])) / (visibleRange[1] - visibleRange[0])
}
